import { notification, Skeleton } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import API_SERVICE from 'shared/services/api-service';
import arrowLeft from '../../../src/img/arrow-left.png';

interface Props{
    location: any;
}

export default function QuestionReport(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setlang] = useState('' as any);
    const RouteParams: any = useParams();

    const refreshItems = () => {
        setFetching(true);
        
        API_SERVICE.fetchwrongQuestionsReport().then(({data: {data: {items}}}) => {
            setItems(items);
            console.log('wrong question item', items)
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#questionReportList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                      
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":      t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                     
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        }).catch(e => {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }).finally(() => {
            setFetching(false);

        });
    };
    
    useEffect(() =>{
        refreshItems();
    },[]);
    if (fetching) {
        return <Skeleton active={true} />;
    }
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                <div className={'list-page-wrapper'}>
                    <div className="container-fluid">
                        <div className={'d-flex justify-space-between mb-3'}>
                            <div className='col-md-12 p-0 d-flex align-items-center'>
                                <div className={lang == 'ar' ? '' : 'mr-4'}>
                                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                </div>
                                <div className={lang == 'ar' ? 'mr-2' : 'mr-2'}>
                                    {!RouteParams['id'] && <h3 className='mb-0'>{t('genDict.wrongQuestionReport')}</h3>}
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 p-0'>
                                <div className='bg-white p-3 br-5px'>
                                    <div className="row">
                                    <div className="col-md-12 pb-3">
                                        <div className="table-responsive table-br-5 box-shadow mt-2">
                                            <table id="questionReportList" className="table  table-meetings table-report">
                                            <thead>
                                                <tr>
                                                    <th className="text-uppercase text-secondary">{t('genDict.question')}</th>
                                                    <th className="text-uppercase text-secondary">{t('genDict.course')}</th>
                                                    <th className="text-uppercase text-secondary">{t('genDict.module')}</th>
                                                    <th className="text-uppercase text-secondary text-center">{t('genDict.wrongMarked')}</th>
                                                    <th className="text-uppercase text-secondary">{t('genDict.updatedAt')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    items && items.map(item => {
                                                        console.log(item);
                                                        return <tr>
                                                            <td className="text-secondary"><span dangerouslySetInnerHTML={{ __html: item?.questions?.title }} /></td>
                                                            <td className="text-secondary">{item?.course?.title}</td>
                                                            <td className="text-secondary">{item?.curriculum?.title}</td>
                                                            <td className="text-secondary text-center">{item?.wrong_count}</td>
                                                            <td className="text-secondary">{ moment(item?.updated_at).format(DATE_FORMAT_LONG)}</td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                </div>
                )
            }
        </AuthConsumer>
    );
}